<figure kb-overlay-figure
  [abstract]="abstract"
  [heading]="heading"
  [link]="link"
  [headingLevel]="headingLevel"
  [class.indented]="indented"
  [class.large-heading]="largeHeading"
  [headingLines]="largeHeading ? 3 : 2"
  [attr.kb-grid-item-columns]="rootColumns"
  [abstractMode]="abstractMode"
>
  <kb-picture
    [aboveFold]="aboveFold"
    [picture]="picture"
    [variants]="variants ?? fallbackVariants"
    [alt]="alt"
    [rootColumns]="rootColumns"
  />
</figure>
